// Circular distressed "VERIFIED" rubber-stamp SVG graphic.
export const VerifiedStamp = ({ size = 128, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      className={className}
      style={{ transform: "rotate(-12deg)" }}
      role="img"
      aria-label="Verified evidence stamp"
      data-testid="verified-stamp"
    >
      <defs>
        <path id="stampTop" d="M 100,100 m -72,0 a 72,72 0 1,1 144,0" fill="none" />
        <path id="stampBottom" d="M 100,100 m 72,0 a 72,72 0 1,1 -144,0" fill="none" />
        <filter id="rough">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="2.2" />
        </filter>
      </defs>
      <g filter="url(#rough)" stroke="currentColor" fill="currentColor" opacity="0.92" className="text-oath-accent">
        <circle cx="100" cy="100" r="86" fill="none" strokeWidth="3.5" />
        <circle cx="100" cy="100" r="78" fill="none" strokeWidth="1.5" />
        <circle cx="100" cy="100" r="40" fill="none" strokeWidth="2.5" />
        <text fontFamily="var(--font-label)" fontSize="11" fontWeight="700" letterSpacing="4" fill="currentColor">
          <textPath href="#stampTop" startOffset="50%" textAnchor="middle">
            RESIDENCEPROOF · EVIDENCE
          </textPath>
        </text>
        <text fontFamily="var(--font-label)" fontSize="11" fontWeight="700" letterSpacing="4" fill="currentColor">
          <textPath href="#stampBottom" startOffset="50%" textAnchor="middle">
            CHAIN OF CUSTODY
          </textPath>
        </text>
        <text
          x="100"
          y="107"
          textAnchor="middle"
          fontFamily="'Space Grotesk', sans-serif"
          fontSize="20"
          fontWeight="700"
          letterSpacing="1"
          stroke="none"
        >
          VERIFIED
        </text>
      </g>
    </svg>
  );
};

export default VerifiedStamp;
